module.exports = __webpack_public_path__ + "static/hyperx-7017b4dc32b0b36954fe983e0f63ed00.png";